import { theme } from '@factorialco/deprecated-design-system'

export const focusStyles = {
  backgroundColor: theme.colors.grey100,
  borderColor: theme.colors.grey400,
  borderWidth: theme.dimensions.s2,
}
